import React, { useEffect, useState } from "react";
import {
  useStripe,
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import { Button, Flex } from "antd";
import "../SelectPaymentMethodModal.scss";
import { mixPostV1 } from "../../../services/mixin";
interface FormCardStripeProps {
  amount: number;
  selected: string;
  loading: boolean;
  setMessage: (mess: string) => void;
  onCancel: () => void;
  onPaymentSuccess?: () => void;
  typeId?: number | string;
  apiEndpoint?: string;
}
const FormCardStripe: React.FC<FormCardStripeProps> = ({
  amount,
  loading,
  selected,
  setMessage,
  onCancel,
  onPaymentSuccess,
  typeId,
  apiEndpoint,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [cardName, setCardName] = useState("");
  const [saveCard, setSaveCard] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const handleSubmit = async (e: any) => {
    console.log(e);

    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      setMessage(
        "Make sure to disable form submission until Stripe.js has loaded.",
      );
      setSubmitting(false);
      return;
    }
    const cardElement = elements.getElement(CardNumberElement);
    if (cardElement) {
      const { token, error } = await stripe.createToken(cardElement);
      if (error) {
        // Handle errors with the card element
        setMessage(error?.message ?? "");
        console.error(error);
        setSubmitting(false);
      } else {
        if (token) {
          // Gọi API thanh toán
          if (token.card && token.card.last4) {
            try {
              const endpoint = apiEndpoint || "/api/webAdmin/paymentPackedStore.php";
              const payload: any = {
                card_name: cardName,
                last_number: token?.card?.last4,
                tokenpayment: token.id,
                is_save: saveCard ? 1 : 0,
              };
              if (typeId) {
                payload.type_id = typeId;
              }
              const res = await mixPostV1(endpoint, payload);
              if (res.status === 1) {
                setMessage("Payment successful!");
                if (typeof onCancel === "function") onCancel();
                if (typeof onPaymentSuccess === "function") onPaymentSuccess();
              } else {
                setMessage(res.message || "Payment failed!");
              }
            } catch (error) {
              setMessage("Payment failed!");
            } finally {
              setSubmitting(false);
            }
          } else {
            setMessage("Card information is invalid!");
            setSubmitting(false);
          }
        } else {
          setMessage("Connect fail!");
          setSubmitting(false);
        }
      }
    } else {
      setMessage("Card element not found.");
      setSubmitting(false);
    }
  };
  const inputStyle = {
    iconColor: "#c4f0ff",
    color: "#ffffff",
    fontWeight: "400",
    fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
    fontSize: "15px",
    fontSmoothing: "antialiased",
    backgroundColor: "#222",
    border: "0.5px solid #888",
    borderRadius: "10px",
    padding: "20px 20px",
    height: "40px",
    boxSizing: "border-box",
    ":-webkit-autofill": {
      color: "#ffffff",
    },
    "::placeholder": {
      color: "#bbb",
      opacity: 1,
    },
  };

  const isBusy = loading || submitting;

  return (
    <div className="spm-card-form">
      <div className="spm-card-row">
        <label className="spm-card-label">Card Name:</label>
        <input
          type="text"
          placeholder="Name on card"
          className="spm-card-input"
          value={cardName}
          onChange={(e) => setCardName(e.target.value)}
        />
      </div>
      <div className="spm-card-row">
        <label className="spm-card-label">Card Number:</label>
        <div className="spm-card-input">
          <CardNumberElement
            options={{
              style: {
                base: inputStyle,
              },
            }}
          />
        </div>
      </div>
      <div className="spm-card-row spm-card-row-flex">
        <div className="spm-card-col">
          <label className="spm-card-label">Expire:</label>
          <div className="spm-card-input">
            <CardExpiryElement options={{ style: { base: inputStyle } }} />
          </div>
        </div>
        <div className="spm-card-col">
          <label className="spm-card-label">CVC:</label>
          <div className="spm-card-input">
            <CardCvcElement options={{ style: { base: inputStyle } }} />
          </div>
        </div>
      </div>
      <div className="spm-card-checkbox-row">
        <input
          type="checkbox"
          id="save-card"
          checked={saveCard}
          onChange={(e) => setSaveCard(e.target.checked)}
        />
        <label htmlFor="save-card" className="spm-card-checkbox-label">
          Save this card for my next payment.
        </label>
      </div>
      <Flex gap={16} justify="center" style={{ marginTop: 24 }}>
        <Button onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button
          type="primary"
          className="spm-payment-btn"
          onClick={handleSubmit}
          loading={isBusy}
          disabled={!selected || isBusy}
        >
          Payment {amount}
        </Button>
      </Flex>
    </div>
  );
};

export default FormCardStripe;
